module.exports = __webpack_public_path__ + "static/media/stijn-bessem-case-hedo-04@2x.f51d25e1.jpg";